// extracted by mini-css-extract-plugin
export default {"skillsContainer":"skillsContainer_pCGD","skills":"skills_Jty4"};